import { AmericanFootballIcon, ArtifactIcon, AssieRulesIcon, BandyIcon, BaseBallIcon, BasketBall3x3, BasketballIcon, BeachSoccerIcon, BeachVolleyIcon, BikeIcon, BoatIcon, BowlsIcon, BoxingIcon, CounterStrikeIcon, CricketIcon, CrossCountryIcon, CurlingIcon, DartsIcon, ESportIcon, FieldHockeyIcon, FloorBallIcon, FootsalIcon, FormulaIcon, GaelicFootballIcon, GaelicHurlingIcon, GolfIcon, GymnasticsIcon, HandballIcon, HockeyIcon, HorseBackIcon, KabaddiIcon, LacrosseIcon, LolIcon, MmaIcon, MotorsportIcon, NordicCombinerIcons, OlympicsIcon, PesapalloIcon, PoolIcon, RampIcon, RinkHockeyIcon, RugbyIcon, SSBMIcon, ShortTrackIcon, ShotgunIcon, ShuttleCockIcon, SkiIcon, SkijumpingIcon, SnookerIcon, SnowboardIcon, SoccerIcon, SpecialIcon, SpeedSkatingIcon, SquashIcon, StreetFighterIcon, TableTennisIcon, TekkenIcon, TennisIcon, VoleyballIcon, WaterpoloIcon, WinterSportIcon, WorldLotteryIcon, } from '~icons/sports';
import { SkeletonIcon } from '~icons/sports/skeleton-icon';
export var name = 'sports';
// Sport icons list with betradar sport ids
export var mapSportIdToSportIcon = {
    1: SoccerIcon,
    2: BasketballIcon,
    3: BaseBallIcon,
    4: HockeyIcon,
    5: TennisIcon,
    6: HandballIcon,
    7: FloorBallIcon,
    9: GolfIcon,
    10: BoxingIcon,
    11: MotorsportIcon,
    12: RugbyIcon,
    13: AssieRulesIcon,
    14: WinterSportIcon,
    15: BandyIcon,
    16: AmericanFootballIcon,
    17: BikeIcon,
    18: SpecialIcon,
    19: SnookerIcon,
    20: TableTennisIcon,
    21: CricketIcon,
    22: DartsIcon,
    23: VoleyballIcon,
    24: FieldHockeyIcon,
    25: PoolIcon,
    26: WaterpoloIcon,
    28: CurlingIcon,
    29: FootsalIcon,
    30: OlympicsIcon,
    31: ShuttleCockIcon,
    32: BowlsIcon,
    34: BeachVolleyIcon,
    36: GymnasticsIcon,
    37: SquashIcon,
    38: RinkHockeyIcon,
    39: LacrosseIcon,
    40: FormulaIcon,
    43: SkiIcon,
    44: ShotgunIcon,
    46: CrossCountryIcon,
    47: NordicCombinerIcons,
    48: SkijumpingIcon,
    49: SnowboardIcon,
    50: SpeedSkatingIcon,
    60: BeachSoccerIcon,
    61: PesapalloIcon,
    71: SquashIcon,
    76: HorseBackIcon,
    81: BoatIcon,
    103: RampIcon,
    104: SkeletonIcon,
    105: ShortTrackIcon,
    108: WorldLotteryIcon,
    109: CounterStrikeIcon,
    110: LolIcon,
    117: MmaIcon,
    127: StreetFighterIcon,
    135: GaelicFootballIcon,
    136: GaelicHurlingIcon,
    137: ESportIcon,
    138: KabaddiIcon,
    142: FormulaIcon,
    153: BasketballIcon,
    155: BasketBall3x3,
    156: TekkenIcon,
    160: SSBMIcon,
    162: ArtifactIcon,
    191: FormulaIcon,
};
export var mapSportUidToSportIcon = {
    '01981cc0-8b60-78e8-af2e-ff564fce1d17': SoccerIcon,
    '01981cc0-8b60-7f3f-9291-cf8654718153': BasketballIcon,
    '01981cc0-8b60-7061-8424-36bc0de0b09f': BaseBallIcon,
    '01981cc0-8b60-7136-a5eb-1359a10fbfb3': HockeyIcon,
    '01981cc0-8b60-7f65-a50e-416bc5a39f03': TennisIcon,
    '01981cc0-8b60-79fd-a7ab-e507af29c409': HandballIcon,
    '01981cc0-8b60-7344-86b5-489415454f60': FloorBallIcon,
    '01981cc0-8b60-70f2-a774-3a02bcc25362': GolfIcon,
    '01981cc0-8b60-7592-b39e-1b525f6f5586': BoxingIcon,
    '01981cc0-8b60-7314-890b-622388a00b42': MotorsportIcon,
    '01981cc0-8b60-73cb-b554-321668c8fb73': RugbyIcon,
    '01981cc0-8b60-76a7-81da-93ad64581c73': AssieRulesIcon,
    '01981cc0-8b60-7574-9a39-a35f75e70803': WinterSportIcon,
    '01981cc0-8b60-7090-ab61-ea6a0a568870': BandyIcon,
    '01981cc0-8b60-72d8-9217-e25f69a791f9': AmericanFootballIcon,
    '01981cc0-8b60-7bfa-bab8-f6a1f45558d7': BikeIcon,
    '01981cc0-8b60-7128-b84a-44adb89845ea': SpecialIcon,
    '01981cc0-8b60-7bec-96f0-e51a01d067c2': SnookerIcon,
    '01981cc0-8b60-75c2-afa2-589640d7450b': TableTennisIcon,
    '01981cc0-8b60-775b-ad57-9c0dd3480fa7': CricketIcon,
    '01981cc0-8b60-7cd3-b4e9-5a2ba8ddb40f': DartsIcon,
    '01981cc0-8b60-7b9b-b651-6713c0f747fa': VoleyballIcon,
    '01981cc0-8b60-7ba9-ac70-aa0a149d282e': FieldHockeyIcon,
    '01981cc0-8b60-76ec-8fa0-a510892bc56c': PoolIcon,
    '01981cc0-8b60-7473-a9f6-b2f3297333a4': WaterpoloIcon,
    '01981cc0-8b60-7dc9-9a94-197c2afc0851': CurlingIcon,
    '01981cc0-8b60-7aa1-8c1a-d2b66edfcebf': FootsalIcon,
    '01981cc0-8b60-76ed-8ad6-7e309809cd5c': OlympicsIcon,
    '01981cc0-8b60-7171-8184-4a21378f9a04': ShuttleCockIcon,
    '01981cc0-8b60-752e-bb9d-36b0e1de34b7': BowlsIcon,
    '01981cc0-8b60-744b-98c1-d575e5662c13': BeachVolleyIcon,
    '01981cc0-8b60-726a-9bf1-6b9ee07a07cb': GymnasticsIcon,
    '01981cc0-8b60-75a2-85c4-6e9dd50568f3': SquashIcon,
    '01981cc0-8b60-7c92-a7e8-d87125997b23': RinkHockeyIcon,
    '01981cc0-8b60-7287-a721-de601271c344': LacrosseIcon,
    '01981cc0-8b60-7c68-8f91-133845cac47f': SkiIcon,
    '01981cc0-8b60-7bc5-abca-d5ae984ca5b2': ShotgunIcon,
    '01981cc0-8b60-7d0c-9d4f-f1e932351fa9': CrossCountryIcon,
    '01981cc0-8b60-7b3c-8b2e-ae043f36d935': NordicCombinerIcons,
    '01981cc0-8b60-77e3-b40c-eac2ca80abc0': SkijumpingIcon,
    '01981cc0-8b60-79b1-8e73-6636d60434ae': SnowboardIcon,
    '01981cc0-8b60-78f7-852b-d98cf153ac6f': SpeedSkatingIcon,
    '01981cc0-8b60-7ea8-be31-75fe3b6334d0': BeachSoccerIcon,
    '01981cc0-8b60-7df1-8183-09802f482767': PesapalloIcon,
    '01981cc0-8b60-778c-bfab-1f07105ba397': HorseBackIcon,
    '01981cc0-8b60-70e3-980d-6b3753fc332f': BoatIcon,
    '01981cc0-8b60-7ffe-91e4-2c6ebf434dd0': RampIcon,
    '01981cc0-8b60-7b6a-9aeb-943adf0c16a4': SkeletonIcon,
    '01981cc0-8b60-7c2c-8914-e6bfec7a19d1': ShortTrackIcon,
    '01981cc0-8b60-7352-a52b-1637e2920d5a': WorldLotteryIcon,
    '01981cc0-8b60-700e-9bad-de8b2308d396': CounterStrikeIcon,
    '01981cc0-8b60-7a6e-a133-7a03e3ff36ff': LolIcon,
    '01981cc0-8b60-7309-8db8-63cf9883cf5a': MmaIcon,
    '01981cc0-8b60-7a1d-846b-aaf8cdb0419c': StreetFighterIcon,
    '01981cc0-8b60-7d60-8822-96fb17a81d31': GaelicFootballIcon,
    '01981cc0-8b60-7a13-8fdd-ef57be32e429': GaelicHurlingIcon,
    '01981cc0-8b60-7700-9d34-498f986fb175': ESportIcon,
    '01981cc0-8b60-78b2-a11a-8fb95f437093': KabaddiIcon,
    '01981cc0-8b60-7db9-aa54-7d66479e4a74': FormulaIcon,
    '01981cc0-8b60-72fe-9565-323dabf8b23e': BasketBall3x3,
    '01981cc0-8b60-7321-9390-46146e96d27e': TekkenIcon,
    '01981cc0-8b60-720c-b08d-90b190a6d0b3': SSBMIcon,
    '01981cc0-8b60-7a9f-a8fd-1b481e4a99e1': ArtifactIcon,
    '0199759c-d1c6-714b-bd2f-fea3ac2f6961': FormulaIcon,
    '0199759c-f6d6-7511-b674-0a18d2749e29': SquashIcon,
    '0199759d-04eb-78bd-aa13-42aed3736bf8': BasketballIcon,
    '0199759d-0f0e-7049-af1a-2f9f13b2bb49': FormulaIcon,
};
